import styled from "styled-components";

export const StyledFooter = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 767px) {
    border-top: 1px solid ${({ theme }) => theme.pallette.silver.secondary};
    padding-top: 24px;
  }
`;
